/* ═══════════════════════════════════════════════════
   ISLAND JEWELS — Custom Shopify Theme JS
═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── NAV SCROLL ── */
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    }, { passive: true });
  }

  /* ── HAMBURGER MENU ── */
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobile-menu');
  var menuClose = document.getElementById('menu-close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('.mob-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  /* ── SMOOTH SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var offset = 72;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ── INQUIRY MODAL ── */
  var modalBackdrop = document.getElementById('modal-backdrop');
  var currentPiece = '';

  function openModal(pieceName) {
    currentPiece = pieceName || 'this piece';
    if (!modalBackdrop) return;
    var titleEl = document.getElementById('modal-title');
    var msgEl = document.getElementById('m-message');
    if (titleEl) titleEl.textContent = 'Enquire about the ' + currentPiece;
    if (msgEl) msgEl.value = "I'm interested in the " + currentPiece + ". Please let me know about availability and pricing.";
    modalBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    var formWrap = document.getElementById('modal-form-wrap');
    var successEl = document.getElementById('modal-success');
    if (formWrap) formWrap.style.display = 'block';
    if (successEl) successEl.style.display = 'none';
    var form = document.getElementById('modal-form');
    if (form) form.reset();
    if (msgEl) msgEl.value = "I'm interested in the " + currentPiece + ". Please let me know about availability and pricing.";
    setTimeout(function () {
      var firstInput = document.getElementById('m-name');
      if (firstInput) firstInput.focus();
    }, 100);
  }

  function closeModal() {
    if (!modalBackdrop) return;
    modalBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Wire up all Enquire buttons
  document.querySelectorAll('.btn-enquire, .btn-enquire-large').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pieceName = btn.getAttribute('data-product') || 'this piece';
      openModal(pieceName);
    });
  });

  if (modalBackdrop) {
    modalBackdrop.addEventListener('click', function (e) {
      if (e.target === modalBackdrop) closeModal();
    });
  }
  var modalCloseBtn = document.getElementById('modal-close-btn');
  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
  var modalViewingLink = document.getElementById('modal-viewing-link');
  if (modalViewingLink) modalViewingLink.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Modal form submit → WhatsApp + email
  var modalForm = document.getElementById('modal-form');
  if (modalForm) {
    modalForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var valid = true;
      var name = document.getElementById('m-name');
      var email = document.getElementById('m-email');
      var nameErr = document.getElementById('m-name-err');
      var emailErr = document.getElementById('m-email-err');

      if (!name || !name.value.trim()) {
        if (nameErr) nameErr.style.display = 'block';
        valid = false;
      } else if (nameErr) nameErr.style.display = 'none';

      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailRe.test(email.value.trim())) {
        if (emailErr) emailErr.style.display = 'block';
        valid = false;
      } else if (emailErr) emailErr.style.display = 'none';

      if (!valid) return;

      var metal = document.getElementById('m-metal');
      var metalText = (metal && metal.value) ? metal.options[metal.selectedIndex].text : 'Not specified';
      var size = document.getElementById('m-size');
      var sizeText = (size && size.value) ? size.value : 'Not specified';
      var message = document.getElementById('m-message');
      var msgText = (message && message.value) ? message.value : '';

      var waNum = document.body.getAttribute('data-wa') || '6285857441637';
      var waMsg = 'New enquiry from Island Jewels website%0A%0A' +
        'Piece: ' + encodeURIComponent(currentPiece) + '%0A' +
        'Name: ' + encodeURIComponent(name.value.trim()) + '%0A' +
        'Email: ' + encodeURIComponent(email.value.trim()) + '%0A' +
        'Metal: ' + encodeURIComponent(metalText) + '%0A' +
        'Size: ' + encodeURIComponent(sizeText) + '%0A' +
        'Message: ' + encodeURIComponent(msgText);

      window.open('https://wa.me/' + waNum + '?text=' + waMsg, '_blank');

      var formWrap = document.getElementById('modal-form-wrap');
      var successEl = document.getElementById('modal-success');
      if (formWrap) formWrap.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
      this.reset();
    });
  }

  /* ── VIEWING FORM → WhatsApp ── */
  var viewingForm = document.getElementById('viewing-form');
  if (viewingForm) {
    viewingForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var valid = true;
      var name = document.getElementById('v-name');
      var email = document.getElementById('v-email');
      var nameErr = document.getElementById('v-name-err');
      var emailErr = document.getElementById('v-email-err');

      if (!name || !name.value.trim()) {
        if (nameErr) nameErr.style.display = 'block';
        valid = false;
      } else if (nameErr) nameErr.style.display = 'none';

      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailRe.test(email.value.trim())) {
        if (emailErr) emailErr.style.display = 'block';
        valid = false;
      } else if (emailErr) emailErr.style.display = 'none';

      if (!valid) return;

      var vType = document.querySelector('input[name="viewing-type"]:checked');
      var vTypeText = vType ? (vType.value === 'bali' ? 'Bali Studio Visit' : 'Virtual Consultation') : 'Not specified';
      var vDate = document.getElementById('v-date');
      var vDateText = (vDate && vDate.value) ? vDate.value : 'Not specified';
      var vTime = document.getElementById('v-time');
      var vTimeText = (vTime && vTime.value) ? vTime.options[vTime.selectedIndex].text : 'Not specified';
      var vNotes = document.getElementById('v-notes');
      var vNotesText = (vNotes && vNotes.value) ? vNotes.value : 'None';

      var waNum = document.body.getAttribute('data-wa') || '6285857441637';
      var waMsg = 'Appointment request from Island Jewels website%0A%0A' +
        'Name: ' + encodeURIComponent(name.value.trim()) + '%0A' +
        'Email: ' + encodeURIComponent(email.value.trim()) + '%0A' +
        'Viewing type: ' + encodeURIComponent(vTypeText) + '%0A' +
        'Preferred date: ' + encodeURIComponent(vDateText) + '%0A' +
        'Preferred time: ' + encodeURIComponent(vTimeText) + '%0A' +
        'Notes: ' + encodeURIComponent(vNotesText);

      window.open('https://wa.me/' + waNum + '?text=' + waMsg, '_blank');

      var successEl = document.getElementById('viewing-success');
      if (successEl) successEl.style.display = 'block';
      this.reset();
      setTimeout(function () {
        if (successEl) successEl.style.display = 'none';
      }, 8000);
    });
  }

  /* ── INTERSECTION OBSERVER FADE-IN ── */
  var fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    fadeEls.forEach(function (el) { observer.observe(el); });
  }

  /* ── PRODUCT PAGE IMAGE THUMBS ── */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.getElementById('product-main-image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) mainImg.src = full;
    });
  });

  /* ── CART COUNT UPDATE (AJAX) ── */
  document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var countEl = document.querySelector('[data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
        }).catch(function () {});
      }, 500);
    });
  });

})();

